import { gql } from '@apollo/client';

// ============================================================================
// QUERIES
// ============================================================================

export const TAREAS_HOUSEKEEPING = gql`
  query TareasHousekeeping($fecha: String, $estado: EstadoTarea, $tipo: TipoTareaHousekeeping, $usuario_id: Int) {
    tareasHousekeeping(fecha: $fecha, estado: $estado, tipo: $tipo, usuario_id: $usuario_id) {
      id
      habitacion_id
      habitacion {
        id
        numero
        tipo
        piso
        estado
      }
      usuario_asignado_id
      usuario_asignado {
        id
        nombre
        usuario
      }
      tipo
      prioridad
      estado
      notas
      notas_completado
      fecha
      hora_inicio
      hora_fin
      creador {
        id
        nombre
      }
      created_at
      updated_at
    }
  }
`;

export const RESUMEN_HOUSEKEEPING = gql`
  query ResumenHousekeeping($fecha: String) {
    resumenHousekeeping(fecha: $fecha) {
      fecha
      pendientes
      en_progreso
      completadas
      canceladas
      habitaciones_en_limpieza
      carga_por_usuario {
        usuario_id
        nombre
        usuario
        pendientes
        en_progreso
        completadas
      }
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

export const CREAR_TAREA_HOUSEKEEPING = gql`
  mutation CrearTareaHousekeeping($input: CrearTareaHousekeepingInput!) {
    crearTareaHousekeeping(input: $input) {
      id
      habitacion_id
      tipo
      prioridad
      estado
      fecha
    }
  }
`;

export const ACTUALIZAR_TAREA_HOUSEKEEPING = gql`
  mutation ActualizarTareaHousekeeping($id: Int!, $input: ActualizarTareaHousekeepingInput!) {
    actualizarTareaHousekeeping(id: $id, input: $input) {
      id
      estado
      notas_completado
      hora_inicio
      hora_fin
    }
  }
`;

export const ASIGNAR_TAREA_HOUSEKEEPING = gql`
  mutation AsignarTareaHousekeeping($id: Int!, $usuario_id: Int!) {
    asignarTareaHousekeeping(id: $id, usuario_id: $usuario_id) {
      id
      usuario_asignado_id
      usuario_asignado {
        id
        nombre
      }
    }
  }
`;
